import { render, staticRenderFns } from "./FaqAndSupportDirectionsDesktop.vue?vue&type=template&id=0ebff68f&scoped=true"
import script from "./FaqAndSupportDirectionsDesktop.vue?vue&type=script&lang=js"
export * from "./FaqAndSupportDirectionsDesktop.vue?vue&type=script&lang=js"
import style0 from "./FaqAndSupportDirectionsDesktop.vue?vue&type=style&index=0&id=0ebff68f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebff68f",
  null
  
)

export default component.exports